import { styled } from "@pigment-css/react";
import { ChevronGrabberVertical } from "@acto/web-common/components";
import { useTranslations } from "@acto/web-common/locales";
import { glassCapsulePress } from "@acto/taskpane/field-sales-2/styles/glassCapsulePress";
import { MenuPopover } from "@acto/taskpane/field-sales-2/components/primitives/MenuPopover";

const Pill = styled("button")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: 8,
  height: 48,
  padding: "0 20px",
  borderRadius: 99,
  border: `1px solid ${theme.fieldSalesTwo.colors.surface.glassBorderStrong}`,
  background: theme.fieldSalesTwo.colors.surface.glassStrong,
  backdropFilter: `blur(${theme.fieldSalesTwo.effects.blurSm})`,
  WebkitBackdropFilter: `blur(${theme.fieldSalesTwo.effects.blurSm})`,
  boxShadow: theme.fieldSalesTwo.shadows.glass,
  cursor: "pointer",
  fontFamily: theme.fieldSalesTwo.font.family,
  fontSize: theme.fieldSalesTwo.font.size[14],
  fontWeight: theme.fieldSalesTwo.font.weight[500],
  color: theme.fieldSalesTwo.colors.neutral[900],
  ...glassCapsulePress(theme, { restShadow: theme.fieldSalesTwo.shadows.glass }),
}));

interface YearFilterPillProps {
  selectedYear: number;
  yearOptions: number[];
  onChange: (year: number) => void;
}

export function YearFilterPill({ selectedYear, yearOptions, onChange }: YearFilterPillProps) {
  const t = useTranslations("kpi");

  return (
    <MenuPopover
      ariaLabel={t("selectYear")}
      trigger={
        <Pill type="button">
          {selectedYear}
          <ChevronGrabberVertical width={22} height={22} />
        </Pill>
      }
      items={yearOptions.map((year) => ({
        label: String(year),
        selected: year === selectedYear,
        onSelect: () => onChange(year),
      }))}
    />
  );
}
